import type { ReactNode } from 'react';
import type { DateRange } from 'react-day-picker';
import { DateRangePicker } from '@/components/ui/date-range-picker';
import { ANALYTICS_MAX_RANGE_DAYS } from '../range-cap';

interface DashboardHeaderProps {
  userName: string;
  dateRange: DateRange | undefined;
  onDateRangeChange: (range: DateRange | undefined) => void;
  /** Replaces the "Dashboard" subtitle, e.g. with the Overview's dashboard switcher. */
  subtitle?: ReactNode;
}

export function DashboardHeader({ userName, dateRange, onDateRangeChange, subtitle }: DashboardHeaderProps) {
  return (
    <div className='flex items-start justify-between'>
      <div className='flex flex-col'>
        <h1 className='text-base font-semibold text-ink'>Hello, {userName}</h1>
        {subtitle ?? <p className='text-sm text-gray-700'>Dashboard</p>}
      </div>
      <DateRangePicker
        inline
        maxDays={ANALYTICS_MAX_RANGE_DAYS}
        value={{ startDate: dateRange?.from, endDate: dateRange?.to }}
        onChange={(range) => onDateRangeChange({ from: range.startDate, to: range.endDate })}
      />
    </div>
  );
}
